export const productPageView = 'ProductPageView'

export const productLaunchEvents = {
    PRODUCT_LAUNCH_PWA: 'ProductLaunchedFromPwa',
    PRODUCT_LAUNCH_WEB: 'ProductLaunchedFromWeb',
};
